module.exports = __webpack_public_path__ + "static/media/logo.c28dd9f9.png";